import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface ApproveVDRFileUploadRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const ApproveVDRFileUpload = createAsyncThunk(
    'dataRoom/approveFileUpload',
    async (
        { engagementId, fileId, fileSourceType }: ApproveVDRFileUploadRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/approve-upload?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not approve file upload at the moment.',
                    'error'
                );
                throw new Error('Failed to approve file upload');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while approving file upload.',
                'error'
            );
            throw error;
        }
    }
);

